import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';
import { enableProdMode } from '@angular/core';


// Crea dinámicamente el <script> de reCAPTCHA
const script = document.createElement('script');
script.src = `https://www.google.com/recaptcha/api.js?render=${environment.recaptcha.siteKey}`;
script.async = true;
document.head.appendChild(script);

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));


